import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.tools.components';

export default defineMessages({
    save: {
        id: `${scope}.label.save`,
        defaultMessage: 'Save',
    },
    addToolLabel: {
        id: `${scope}.label.addTool`,
        defaultMessage: 'Add tool',
    },
    editToolLabel: {
        id: `${scope}.label.editTool`,
        defaultMessage: 'Edit tool',
    },
    deleteToolLabel: {
        id: `${scope}.label.deleteTool`,
        defaultMessage: 'Delete tool',
    },
    nameColumnLabel: {
        id: `${scope}.grid.column.name`,
        defaultMessage: 'Name',
    },
    descriptionColumnLabel: {
        id: `${scope}.grid.column.description`,
        defaultMessage: 'Description',
    },
    importToolDescription: {
        id: `${scope}.importToolDescription`,
        defaultMessage: 'You can import tools from an excel file by using'
    },
    importToolDescriptionLinkText: {
        id: `${scope}.importToolDescriptionLinkText`,
        defaultMessage: 'this template'
    },
    upload: {
        id: `${scope}.upload`,
        defaultMessage: 'Upload'
    },
    fileImportSuccess: {
        id: `${scope}.fileImportSuccess`,
        defaultMessage: 'Tools imported successfully'
    },
    fileImportError: {
        id: `${scope}.fileImportError`,
        defaultMessage: 'Could not process the uploaded file'
    },
    importToolLabel: {
        id: `${scope}.importToolLabel`,
        defaultMessage: 'Import Tools items using Excel'
    },
    pasteImportToolLabel: {
        id: `${scope}.pasteImportToolLabel`,
        defaultMessage: 'Paste Tools items using copy-paste'
    },
    pasteToolDialogTitle: {
        id: `${scope}.pasteToolDialogTitle`,
        defaultMessage: 'Import tools using copy-paste',
    },
    pasteToolHelpText: {
        id: `${scope}.pasteToolHelpText`,
        defaultMessage: 'Copy data from Excel and paste it here. Required columns are <b>name</b> and <b>description</b>.',
    },
    pasteToolHelpText2: {
        id: `${scope}.pasteToolHelpText2`,
        defaultMessage: 'You can use Tab, Comma, or Semicolon as separators.',
    },
    separatorLabel: {
        id: `${scope}.separatorLabel`,
        defaultMessage: 'Separator:',
    },
    toolTextFieldLabel: {
        id: `${scope}.toolTextFieldLabel`,
        defaultMessage: 'Paste your data here',
    },
    rowError: {
        id: `${scope}.rowError`,
        defaultMessage: 'Row {rowNo}: {message}',
    },
    moreErrors: {
        id: `${scope}.moreErrors`,
        defaultMessage: 'And {count} more errors...',
    },
    previewTitle: {
        id: `${scope}.previewTitle`,
        defaultMessage: 'Preview ({rowCount} rows)',
    },
    showsOnlyFirst50Rows: {
        id: `${scope}.showsOnlyFirst50Rows`,
        defaultMessage: 'Showing only the first 50 rows…',
    },
    cancel: {
        id: `${scope}.cancel`,
        defaultMessage: 'Cancel',
    },
    import: {
        id: `${scope}.import`,
        defaultMessage: 'Import',
    },
});